(() => {
  if (window.awoocoVariantAutoselect) return;
  window.awoocoVariantAutoselect = true;

  const observedPickers = new WeakSet();

  const checkedValue = (picker, index) =>
    picker.querySelector(`fieldset[data-index="${index}"] input[is-value]:checked`)?.value;

  const findInput = (picker, index, value) =>
    Array.from(picker.querySelectorAll(`fieldset[data-index="${index}"] input[is-value][type="radio"]`)).find(
      (input) => input.value === value
    );

  // Earlier options (e.g. Color) weigh more, so they are kept when possible.
  const matchScore = (variant, wanted, skipIndex) =>
    variant.options.reduce(
      (score, value, i) => (i !== skipIndex && value === wanted[i] ? score + 2 ** (wanted.length - i) : score),
      0
    );

  const resolveClick = (picker) => {
    const click = picker.awoocoPendingClick;
    picker.awoocoPendingClick = null;
    if (!click) return;

    const { index, value } = click;
    const variant = picker.currentVariant;
    if (variant && variant.available && variant.options[index] === value) return;

    const wanted = Array.from(picker.querySelectorAll('fieldset[data-index]'), (_, i) => checkedValue(picker, i));
    wanted[index] = value;

    const candidates = (picker._allVariantsJSON || []).filter((v) => v.available && v.options[index] === value);
    if (!candidates.length) return;

    const best = candidates.reduce((a, b) => (matchScore(b, wanted, index) > matchScore(a, wanted, index) ? b : a));

    const changes = best.options
      .map((optionValue, i) => (checkedValue(picker, i) === optionValue ? null : findInput(picker, i, optionValue)))
      .filter((input) => input !== null);
    if (!changes.length || changes.includes(undefined)) return;

    changes.forEach((input) => {
      input.checked = true;
    });
    changes[changes.length - 1].dispatchEvent(new Event('change', { bubbles: true }));
  };

  // The theme toggles "loading" on the picker while it re-renders after a change,
  // and skips its variant:change event when the resolved variant is unchanged.
  const observePicker = (picker) => {
    if (observedPickers.has(picker)) return;
    observedPickers.add(picker);
    new MutationObserver(() => {
      if (!picker.classList.contains('loading') && picker.awoocoPendingClick) {
        setTimeout(() => resolveClick(picker), 0);
      }
    }).observe(picker, { attributes: true, attributeFilter: ['class'] });
  };

  document.addEventListener(
    'change',
    (event) => {
      if (!event.isTrusted) return;
      const input = event.target;
      if (!(input instanceof HTMLInputElement) || !input.hasAttribute('is-value')) return;
      const picker = input.closest('hdt-variant-picker');
      const fieldset = input.closest('fieldset[data-index]');
      if (!picker || !fieldset) return;

      observePicker(picker);
      picker.awoocoPendingClick = { index: parseInt(fieldset.dataset.index, 10), value: input.value };
    },
    true
  );
})();
